import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import Workflow from '../Workflow';
import WorkflowAudit from '@/components/WorkflowAudit.vue';

@Component({
  components: {
    WorkflowAudit,
  },
  filters: {
    Date(data: any) {
      return moment(data).format('MM-DD');
    },
    WeekDay(data: any) {
      moment.locale('zh-cn');
      return moment(data).format('dddd');
    },
  },
})
export default class TripInfoAudit extends Vue {
  private $api: any;
  private isLoading: boolean = false;
  private tripinfo: any = []; // 接口获取的行程信息
  private trip: any; // 路由获取的行程信息
  private Remark: any = ''; // 备注
  private StartEndPlace: any = ''; // 城市拼接
  private Week: any = ''; // 星期

  private workFlowData: any = []; // 工作流按钮权限
  private WorkflowItemCode: any = '0033'; // 工作流审核时所需Code

  private async created() {
    this.trip = JSON.parse(localStorage.getItem('tripInfo') || '');
    // 根据ID获取详情信息
    this.getTripInfo();
    this.getWorkFlow();
  }
  // 获取行程信息
  private async getTripInfo() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });
    const params = {
      TripTrafficId: this.trip.TripTrafficId,
    };
    const result = await this.$api.httpGet('Membership/TripBookTicket/GetTripInfomationWeChat', params);
    if (result.Success) {
      if (result.Data) {
        this.tripinfo = result.Data;
        this.StartEndPlace = this.tripinfo.StartPlace + '——' + this.tripinfo.EndPlace;
        this.Week = moment(this.tripinfo.StartTime).format('MM-DD') + '    ' + moment(this.tripinfo.StartTime).format('dddd');
      }
      this.$toast.clear();
      this.isLoading = true;
    } else {
      this.$toast.clear();
      this.isLoading = true;
      this.$dialog.alert({
        message: result.AllMessages,
      });
    }
  }

  // 获取工作流信息
  private getWorkFlow() {
    Workflow.GetRuntimeItem('0033', this.trip.TripTrafficId, (response: any) => {
        if (response.Success) {
          if (response.Data) {
            this.workFlowData = response.Data;
          }
        } else {
          this.$dialog.alert({
            title: '错误',
            message: response.AllMessages,
          });
        }
    }, (error: any) => {
        console.log(error);
    });
  }

  private async sendWechatMsg(msgModel: any) {
    const result = await this.$api.httpPost('Membership/TripInfo/PostSendMessageAduit', msgModel);
    this.$toast.clear();
    this.isLoading = true;
    if (result.Success) {
      if (result.Data) {
        this.$dialog.alert({
          title: '审核成功!',
        }).then(() => {
          this.$router.go(-1);
        });
      }
    } else {
      this.$dialog.alert({
          title: '发送消息',
          message: result.AllMessages,
      });
  }
  }

  // 审核成功后事件（监听审核结果）
  private auditCallBack(item: any) {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });
    // 发送微信消息
    const msgModel = {
      WorkFlowStatus: item,
      TripTrafficId: this.trip.TripTrafficId,
    };
    setTimeout(() => {
      this.sendWechatMsg(msgModel);
    }, 4000);
    
  }
}
